import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=f9f8f09a"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9f8f09a')) {
      api.createRecord('f9f8f09a', component.options)
    } else {
      api.reload('f9f8f09a', component.options)
    }
    module.hot.accept("./BasicInfo.vue?vue&type=template&id=f9f8f09a", function () {
      api.rerender('f9f8f09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/funders/view/BasicInfo.vue"
export default component.exports